<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1.titulo Gestão Fila Analise Automatizada
    el-card(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clear",
        :configuracaoFiltro="configuracaoFiltro",
        @search="pesquisar"
        :showPesquisaAvancada="false"
        placeholder="Pesquise pelo número do processo"
      )
    app-modal-fila-manutencao(
      v-if="showModal"
      @closeModal="closeModal"
      :conteudoModal="conteudoModal"
      :filtroRapido="filtroRapido"
    )
    app-modal-visualizar-completo(
      v-if="showModalVisualizarProcesso && idProcesso !== null",
      @closeModal="showModalVisualizarProcesso = false",
      :idProcesso="idProcesso",
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso",
      :tipo="tipoProcesso"
    )
    app-listagem.tabela(
      :has-refresh-button="false",
      :json-headers="colunas",
      :json-data="itens",
      :pagina="filtro.pagina",
      :hasFiltroRapido="false",
      :filtro="filtro",
      :totalElements="totalElements",
      @updateListagem="buscarDadosTabela",
      @changePage="changePage",
      @executar="executar"
      )
</template>
<script>
import {buscarFilaAnaliseAutomatizada, regerarAnalise, buscarInformacoesAnalise} from '@/utils/manutencao'
import AppModalFilaManutencao from '@/screens/manutencao/components/modal/AppModalFilaManutencao.vue'
import AppModalVisualizarCompleto from '../analise/components/modal/AppModalVisualizarCompleto.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem.vue'
import FILTRO_EMPTY from '../../models/filtro'
import Filtro from '@/screens/analise/listagem/Filtro'
const BaseFiltro = require('../analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    AppModalFilaManutencao,
    AppModalVisualizarCompleto,
    AppNotificacao,
    AppListagem,
    Filtro
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tentativas', propriedade: 'tentativas', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Data Cadastro', propriedade: 'dataCadastro', ordem: 6, acoes: [] },
        { id: 6, titulo: 'Protocolo', propriedade: 'protocolo', ordem: 7, acoes: [] },
        { id: 7,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 8,
          acoes: [
            { id: 1, nome: 'Vericar status', icone: 'fa-file', codigo: 'VERIFICA_STATUS', ordem: 1, show: this.showStatusAnaliseAutomatizada },
            { id: 2, nome: 'Regerar', icone: 'fa-file', codigo: 'REGERAR', ordem: 2, show: this.showRegerarAnaliseAutomatizada },
            { id: 3, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 3, show: this.showVisualizarProcesso }
          ]
        }
      ],
      itens: [],
      pagina: 0,
      totalElements: 0,
      showModal: false,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      showModalVisualizarProcesso: false,
      setor: null,
      conteudoModal: null,
      filtro: FILTRO_EMPTY('GESTAO_FILA_ANALISE'),
      filtroRapido: null,
      pesquisa: '',
      configuracaoFiltro: {}
    }
  },

  created () {
    this.buscarDadosTabela()
  },

  methods: {
    async buscarDadosTabela (isChangePage) {
      if (!isChangePage) this.pagina = 0
      const resposta = await buscarFilaAnaliseAutomatizada(this.pagina, this.pesquisa)
      this.itens = resposta?.content.map(r => ({numeroProcesso: r.numeroProcesso, cpfCnpjInteressado: r.interessadoCpfCnpj, nomeRazaoSocialInteressado: r.interessadoNomeRazaoSocial, status: r.status, jobId: r.jobId, tentativas: r.tentativas, dataCadastro: this.formataData(r.dataCadastro), protocolo: r.protocolo, idFila: r.idFila, idProcesso: r.idProcesso, tipoCadastroProcesso: r.tipoCadastroProcesso.codigo}))
      this.totalElements = resposta?.totalElements
    },
    clear () {
      this.pesquisa = ''
      this.buscarDadosTabela()
    },
    async changePage (newValue) {
      this.pagina = newValue - 1
      await this.buscarDadosTabela(true)
    },
    formataData (data) {
      return `${data[2]}/${data[1]}/${data[0]}`
    },
    closeModal () {
      this.showModal = false
      this.conteudoModal = null
    },

    async pesquisar (parametros) {
      this.pesquisa = parametros.campoSimples
      this.buscarDadosTabela()
    },

    async VERIFICA_STATUS (_this, { item }) {
      const resposta = await buscarInformacoesAnalise(item?.jobId)
      if (resposta?.jobStatus) {
        this.showModal = true
        if (resposta?.jobStatus === 'esriJobSucceeded') this.conteudoModal = {mensagem: 'Analise gerada com sucesso no ArcGis.'}
        else if (resposta?.jobStatus === 'esriJobExecuting') this.conteudoModal = {mensagem: 'Analise em andamento no ArcGis.'}
        else this.conteudoModal = {mensagem: 'Falha no processamento do ArcGis necessario recall.'}
      }
    },
    async REGERAR (_this, { item }) {
      const resposta = await regerarAnalise(item.idFila)
      if (resposta === 'ok') {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Analise Regerada')
        await this.buscarDadosTabela()
      } else this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Ocorreu um erro ao regerar a analise')
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.idProcesso
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCadastroProcesso
      this.protocolo = item.protocolo
      this.showModalVisualizarProcesso = true
    }
  }
}
</script>
<style lang="scss" scoped>
    .color-default {
      color: #009d64 !important;
      font-size: 16px;
    }
    .titulo {
      margin-top: 0;
      margin-left: 15px;
    }
    .box-processo {
      min-width: 700px;
      padding-left: 3px;
      padding-right: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/GestaoFilaAnaliseAutomatizada.vue